import { render, staticRenderFns } from "./Corporatepayment.vue?vue&type=template&id=04859017&scoped=true"
import script from "./Corporatepayment.vue?vue&type=script&lang=js"
export * from "./Corporatepayment.vue?vue&type=script&lang=js"
import style0 from "./Corporatepayment.vue?vue&type=style&index=0&id=04859017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04859017",
  null
  
)

export default component.exports